import {DatePicker, Form, Select, Switch} from 'antd';
import SubmitButton from 'components/Startup/components/SubmitButton';
import styles from './financial.module.scss';

/**
 * The filter bar every Financials subtab shares.
 *
 * All four screens carried their own copy of these four controls in a bare
 * horizontal antd form, where the Status label overlapped its own select and
 * the export button was painted underneath the dropdown next to it. One
 * component, one layout: the filters on the left, the actions on the right.
 *
 * `form`, `onFinish` and `initialValues` stay with the caller — each subtab
 * builds its own query variables from these same field names.
 */

const STATUS_HELP = (
  <>
    <span>
      PENDING Status includes: Open, Created, Filled, Pending, Partially Filled.
    </span>
    <br />
    <span>COMPLETED Status includes: Settled, Funded</span>
    <br />
    <span>FAILED Status includes: Rejected, Cancelled</span>
  </>
);

export const MetricsFilterBar = ({
  form,
  initialValues,
  onFinish,
  loading,
  actions,
}) => (
  <div className={styles.filters}>
    <Form
      layout="vertical"
      form={form}
      initialValues={initialValues}
      className={styles.form}
      onFinish={onFinish}>
      <Form.Item name="startDate" label="From">
        <DatePicker placeholder="Start date" showTime allowClear />
      </Form.Item>
      <Form.Item name="endDate" label="To">
        <DatePicker placeholder="End date" showTime allowClear />
      </Form.Item>
      <Form.Item
        name="allTime"
        label="All time"
        valuePropName="checked"
        tooltip="Ignores the dates above and reports over the platform's whole history.">
        <Switch />
      </Form.Item>
      <Form.Item tooltip={STATUS_HELP} name="status" label="Status">
        <Select placeholder="All" style={{width: 150}} allowClear>
          <Select.Option value="ALL">All</Select.Option>
          <Select.Option value="PENDING">Pending</Select.Option>
          <Select.Option value="COMPLETED">Completed</Select.Option>
          <Select.Option value="FAILED">Failed</Select.Option>
        </Select>
      </Form.Item>
      <SubmitButton
        smallWidth
        disabled={loading}
        label={loading ? 'Loading…' : 'Apply'}
      />
    </Form>
    {actions ? <div className={styles.filterActions}>{actions}</div> : null}
  </div>
);
